// @NOTE order is important here for sorting
export const AmlHitAiAnalysisStatusEnum = {
  true_positive: 'true_positive',
  false_positive: 'false_positive',
  manual_review: 'manual_review',
} as const;
export type AmlHitAiAnalysisStatusEnum =
  (typeof AmlHitAiAnalysisStatusEnum)[keyof typeof AmlHitAiAnalysisStatusEnum];
